import { render } from "./TestSMSComponent.vue?vue&type=template&id=09dcf71a"
import script from "./TestSMSComponent.vue?vue&type=script&lang=js"
export * from "./TestSMSComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__